import React, { useEffect, useMemo, useRef, useState } from 'react';
import Layout from '../../Layout';
import PoolingDataDetailT from './PoolingDataDetailT';
import { Breadcrumb, Input, Table, Pagination, ConfigProvider, notification, Switch, Form, Tooltip, Space, Button, Select, Flex, Spin } from 'antd';
import type { TableColumnsType, TableProps, TooltipProps } from 'antd';
import {
  EyeOutlined, EditOutlined,
  DeleteOutlined,
  CopyOutlined,
  DownOutlined,
  CloseCircleOutlined,
  UserAddOutlined,
  BranchesOutlined,
  InfoCircleFilled,
  DeleteFilled,
  PlusOutlined,
} from '@ant-design/icons';
import type { SearchProps } from 'antd/es/input/Search';
import viVN from 'antd/locale/vi_VN';
import { Link } from 'react-router-dom';
import './PoolingDataSetup.scss'
import './PoolingDataDetail.scss'
import PopupShowData from './ComponentPoolingData/PopupShowData';
import ShowParam from './ShowParam';
import ModalParamCreate from './Modal/ModalParamCreate';
import ModalParamEdit from './Modal/ModalParamEdit';
import { datetimeFormat, formatNumber, mixGetV2, mixPostV2 } from '../../services/mixin';
import EmptyComponent from '../../components/EmptyComponent/EmptyComponent';
import ModalDeleteManager from '../../components/ModalDeleteManager';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import { set } from 'lodash';

interface DataType {
  id: number;
  key: number;
  name: string;
  maparam: string;
  date: string;
  status: number
}

const { Search } = Input
const PoolingDataSetup: React.FC = () => {
  const [isShowParam, setShowParam] = useState(false)
  const [openParamCreate, setOpenParamCreate] = useState(false)
  const [openParamEdit, setOpenParamEdit] = useState(false)
  const [stData, setStData] = useState<any>({
    groups: [],
    name: '',
    desc: '',
    clear: 0,
  })

  const newid = (prefix = "") => `${prefix}${Date.now()}${Math.random().toString(36).slice(2, 7)}`;

  const columns: TableColumnsType<DataType> = [
    {
      title: 'Hành động',
      dataIndex: '',
      align: 'left',
      render: (text, record: any) => (
        <>
          <div className="t-hd-table v2">
            <Switch
              checked={record.status === 1}
              // checked={record.status === 1}
              className="rs-switch rs-switch--sm"
              onChange={(status) => updateStatusCondition(record.key, status)}
            />
            <div className="item-hd-table" onClick={() => { setShowParam(true); setDataDetail(record) }}><span><EyeOutlined /></span></div>
            <div
              className="item-hd-table cl-1890FF cursor-pointer"
              onClick={() => {
                setIsCreateCondition(2)
                getDetail(record.key)
              }}
            ><EditOutlined /></div>
            <div
              className="item-hd-table dust-red-6 cursor-pointer"
              onClick={() => { setSelectedId(record.id); setShowDeleteModal(true) }}
            ><DeleteOutlined /></div>
            <div
              className="item-hd-table cl-1890FF cursor-pointer"
              onClick={() => { dub(record) }}
            ><CopyOutlined /></div>
          </div>
        </>
      ),
    },
    {
      title: 'Tên Điều kiện',
      align: 'left',
      dataIndex: 'name',
    },
    {
      title: 'Mô tả',
      dataIndex: 'describe',
      align: 'left',
    },
    // {
    //   title: 'Ngày tạo',
    //   dataIndex: 'date',
    //   align: 'right',
    //   sorter: {
    //     compare: (a: any, b: any) => a.date - b.date,
    //     multiple: 1,
    //   },
    // },
  ];

  // const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
  //   console.log('selectedRowKeys changed: ', newSelectedRowKeys);
  //   setSelectedRowKeys(newSelectedRowKeys);
  // };

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  // };

  const onChangeTB: TableProps<DataType>['onChange'] = (pagination, filters, sorter, extra) => {
    // console.log('params', pagination, filters, sorter, extra);
  };

  // const setShowNoti = () => {
  //   setShowData(false)
  //   openNotification()
  // };

  const [api, contextHolder] = notification.useNotification()
  const openNotification = (type: 'success' | 'info' | 'warning' | 'error' = 'success', message = 'Request success!') => {
    api[type]({
      message: message,
      placement: 'bottomRight',
      className: 'single-message'
    })
  }

  const text = <span>Thông tin trùng lặp giữa các nguồn khi thỏa mãn tất cả điều kiện thiết lập bên dưới:</span>;
  const [arrow, setArrow] = useState<'Show' | 'Hide' | 'Center'>('Show');

  const mergedArrow = useMemo<TooltipProps['arrow']>(() => {
    if (arrow === 'Hide') {
      return false;
    }

    if (arrow === 'Show') {
      return true;
    }

    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const [isCreateCondition, setIsCreateCondition] = useState(0) // 0: default - 1: create - 2: edit
  const [formLoading, setFormLoading] = useState(false)
  const formRef: any = useRef(null)
  const onFormSubmit = async () => {
    if (stData.name.trim() === '') {
      openNotification('error', 'Vui lòng nhập tên điều kiện!')
      return
    }
    if (stData.groups.length === 0 || stData.groups[0].items.length === 0) {
      openNotification('error', 'Vui lòng thêm ít nhất 1 điều kiện!')
      return
    }
    const listNull = stData.groups[0].items.filter((x: any) => !x.field);
    if (listNull.length > 0 ) {
      openNotification('error', `Có ${listNull.length} điều kiện chưa chọn trường! Vui lòng kiểm tra lại.`)
      return
    }
    setFormLoading(true)
    let api = '/api/v1/be/data_migration'
    const temps = [] as any
    stData.groups[0].items.map((val: any, index: any) => {
      temps.push({
        column_warehouse_id: 0,
        source_column_warehouse_id: 0,
        key_params_tamp: val.field,
        pos: index + 1,
        more_migration_id: val.more_migration_id || 0,
        is_unknow: val.is_unknow,
      })
    })
    const params = {
      more_migrations: JSON.stringify(temps),
      name: stData.name,
      describe: stData.desc,
      is_active: 1,
    } as any
    if (isCreateCondition === 2) {
      params['_method'] = 'PUT'
      api = `/api/v1/be/data_migration/${selectedId}`
    }
    const res = await mixPostV2(api, params)
    setFormLoading(false)
    if (res.status) {
      openNotification('success', 'Thao tác thành công!')
      getItems()
      setStData({
        groups: [],
        name: '',
        desc: '',
        clear: newid(),
      })
      setIsCreateCondition(0)
    } else {
      openNotification('error', res.error[Object.keys(res.error)[0]])
    }
  }

  const onFinish = async (values: any) => {
    setFormLoading(true)
    const { title, status, conditions } = values

    if (!conditions) {
      openNotification('error', 'Vui lòng thêm ít nhất 1 điều kiện!')
      setFormLoading(false)
      return
    }

    const moreMigrations = conditions.map((item: any) => ({
      more_migration_id: item?.more_migration_id ? item.more_migration_id : 0,
      source_column_warehouse_id: item.condition,
      is_unknow: item.is_unknow,
    }))
    const is_active = status ? 1 : 0

    let params: any = {
      name: title,
      is_active,
      more_migrations: JSON.stringify(moreMigrations),
      describe: '',
    }

    let res: any
    if (isCreateCondition === 1) {
      res = await mixPostV2('/api/v1/be/data_migration', params)
    }
    if (isCreateCondition === 2) {
      params['_method'] = 'PUT'
      res = await mixPostV2(`/api/v1/be/data_migration/${selectedId}`, params)
    }

    if (res.status) {
      openNotification('success', 'Tạo điều kiện gộp thành công!')
      setIsCreateCondition(0)
      setFormLoading(false)
      setSelectedId(null)
      getItems()
    } else {
      setFormLoading(false)
      openNotification('error', res.msg)
    }
  }

  // GET LIST
  const [tableLoading, setTableLoading] = useState(false)
  const [items, setItems] = useState({
    list: [],
    total: 0,
  })
  const [params, setParams] = useState({
    sort: 'id,desc',
    limit: 10,
    page: 1,
  })

  const getItems = async (searchName = '') => {
    setTableLoading(true)
    let url = `/api/v1/be/data_migrations?sort[]=id,desc&limit=${params.limit}&page=${params.page}`
    if (searchName) {
      url += `&name=${searchName}`
    }
    const res = await mixGetV2(url)

    if (res.status) {
      const list = res.data.items.map((item: any) => ({
        ...item,
        key: item.id,
        date: datetimeFormat(item.created_at),
        maparam: item.describe,
        status: item.is_active,
      }))
      setItems({
        list: list,
        total: res.data.total
      })
      setTableLoading(false)
    }
  }
  const onSearch: SearchProps['onSearch'] = (value, _e, info) => getItems(value)
  // END GET LIST

  // GET DETAIL
  const [selectedId, setSelectedId] = useState<any>(null)
  const [detailLoading, setDetailLoading] = useState(false)
  const getDetail = async (id: number) => {
    setSelectedConditions([])
    setConditionList(conditions)
    setDetailLoading(true)
    setSelectedId(id)
    const res = await mixGetV2(`/api/v1/be/data_migration/${id}`)
    setDetailLoading(false)
    if (res.status) {
      const groupsData = { id: newid("g_"), type: "AND", items: [] as any[] }
      const temps = res.data.more_migration.sort((a: any, b: any) => a.pos - b.pos)
      temps.map((item: any) => {
        groupsData.items.push({
          id: newid("i_"),
          field: item.key_params_tamp,
          more_migration_id: item.more_migration_id,
          is_unknow: item.is_unknow
        })
      })
      setStData({
        groups: [groupsData],
        name: res.data.name,
        desc: res.data.describe,
        clear: newid(),
      })
    }
  }
  // END GET DETAIL

  // GET CONDITION LIST
  const [selectedConditions, setSelectedConditions] = useState<any>([])
  const [conditions, setConditions] = useState<any>([])
  const [conditionList, setConditionList] = useState<any>([])
  const getConditionList = async (type: string = '') => {
    try {
      const res = await mixGetV2('/api/v1/be/source_column_warehouses?is_active=1')
      if (res.status) {
        const result = res.data.items.map((item: any) => ({
          value: item.id.toString(),
          label: item.name,
        }))
        setConditions(result)
        conditionListFunc(result)
      }
    } catch (error) {

    }
  }

  const conditionListFunc = (list?: any) => {
    const arr = list ? list : conditions
    const result: any = []
    // eslint-disable-next-line array-callback-return
    arr.map((item: any) => {
      const isExist = selectedConditions.includes(item.value)
      if (!isExist) {
        result.push(item)
      }
    })
    setConditionList(result)
  }
  // END GET CONDITION LIST

  useEffect(() => {
    getItems()
    getConditionList()

  }, [])
  useEffect(() => {
    getItems()
  }, [params])

  const onValuesChange = (changedFields: any, allFields: any) => {
    const conditionsField = allFields?.conditions

    if (conditionsField?.length > 0) {
      const conditionIds = conditionsField.map((item: any) => item?.condition)
      conditionListFunc()
      setSelectedConditions(conditionIds)
    }
  }

  // UPDATE STATUS CONDITION
  const updateStatusCondition = async (id: number, status: boolean) => {
    const params = {
      is_active: status ? 1 : 0,
      _method: 'PUT'
    }

    try {
      const res = await mixPostV2(`/api/v1/be/data_migration/${id}`, params)

      if (res.status) {
        openNotification('success', 'Cập nhật trạng thái thành công!')
        getItems()
      }
    } catch (error) { }
  }
  // END UPDATE STATUS CONDITION

  // DELETE CONDITION
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const deleteCondition = async () => {
    const params = {
      _method: 'DELETE'
    }

    try {
      const res = await mixPostV2(`/api/v1/be/data_migration/${selectedId}`, params)

      if (res.status) {
        openNotification('success', 'Xóa điều kiện gộp thành công!')
        getItems()
        setShowDeleteModal(false)
        setSelectedId(null)
        setIsCreateCondition(0)
      }
    } catch (error) { }
  }
  // END DELETE CONDITION

  const newOptions = (list?: any) => {
    const arr = list ? list : conditions
    const result: any = []
    // eslint-disable-next-line array-callback-return
    arr.map((item: any) => {
      const isExist = selectedConditions.includes(item.value)
      if (!isExist) {
        result.push(item)
      }
    })
    setConditionList(result)
  }

  const [detailData, setDataDetail] = useState({} as any)

  const dub = async (item: any) => {
    const params = {
      name: `${item.name} (Coppy)`,
      describe: item.describe
    }

    try {
      const res = await mixPostV2(`/api/v1/be/data_migration_create_id/${item.id}`, params)
      if (res.status) {
        openNotification('success', 'Xóa điều kiện gộp thành công!')
        getItems()
      }
    } catch (error) { }
  }

  return (
    <div className='pooling-data-auto-detail customer-list'>
      {contextHolder}
      {/* <Helmet>
        <title>THACO AUTO CRM</title>
      </Helmet> */}
      <Layout>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: 'Khách hàng', },
            { title: <Link to="/customer/pooling-data">Gộp dữ liệu khách hàng</Link>, },
            { title: 'Điều kiện gộp', },
          ]}
          title='Điều kiện gộp'
          backLink='/customer/pooling-data'
          className='gutter-block-end fix-zindex'
        />

        <div className="t-title-back-button-right">
          <Button
            icon={<BranchesOutlined />}
            type='primary'
            className="rs-button rs-button--sm"
            onClick={() => {
              setIsCreateCondition(1)
              setStData({
                groups: [],
                name: '',
                desc: '',
                clear: newid(),
              })
            }}
          >Thêm bộ điều kiện</Button>
        </div>

        <div className={isCreateCondition === 0 ? '' : 'colum2-1fr-400'}>
          <div className="left-content">
            {/* Fillter block */}
            <div className='filter-block t-mb-18'>
              <div className='t-search-block w-100'>
                <Search placeholder="Tìm kiếm tên" onSearch={onSearch} />
              </div>

              {/* <div className='filter-select'>
                <div
                  className='btn-select-show'
                >
                  <span className="content-select" onClick={() => setActive(true)} >{isShowValue}</span>
                  <div
                    className={`icon-down ${showSelectFilter ? "active" : ""}`}
                    onClick={() => setActive(true)}
                  >
                    <DownOutlined />
                  </div>
                  <div
                    className={`icon-close ${showSelectFilter ? "active" : ""}`}
                    onClick={() => handleClearFilter('Chọn bộ lọc')}
                  >
                    <CloseCircleOutlined />
                  </div>
                </div>
                <div className={`list-filter ${showSelectFilter ? "active" : ""}`}>
                  <div className="list-item">
                    <div className="item-select" onClick={() => handleClearFilter('Chọn hệ thống 1')} >Chọn hệ thống 1</div>
                    <div className="item-select" onClick={() => handleClearFilter('Chọn hệ thống 2')} >Chọn hệ thống 2</div>
                    <div className="item-select" onClick={() => handleClearFilter('Chọn hệ thống 3')} >Chọn hệ thống 3</div>
                    <div className="item-select" onClick={() => handleClearFilter('Chọn hệ thống 4')} >Chọn hệ thống 4</div>
                  </div>
                </div>
              </div> */}

              {/* <div
                className="btn-input btn-primary"
                onClick={() => setOpenParamCreate(true)}
              >
                <div className="text">Tạo mới</div>
              </div> */}
            </div>

            <div className="t-table-block t-table-pooling-data-auto-detail">
              <Table
                rowClassName={(record, index) => index % 2 === 0 ? 'table-row-dark' : 'table-row-light'}
                // rowSelection={rowSelection}
                columns={columns}
                // dataSource={data}
                dataSource={items.list}
                onChange={onChangeTB}
                pagination={false}
                showSorterTooltip={false}
                loading={tableLoading}
              />

              <ConfigProvider locale={viVN}>
                <div className="pagination-block">
                  <Pagination
                    total={items.total}
                    align="center"
                    showSizeChanger
                    showQuickJumper
                    itemRender={(page, type, originalElement) => {
                      // Chỉ custom khi là nút số trang
                      if (type === 'page') {
                        return <span>{formatNumber(page)}</span>;
                      }
                      // prev / next / jump-prev / jump-next giữ nguyên
                      return originalElement;
                    }}
                    showTotal={(total) => `Tổng cộng ${total} trang`}
                    locale={{ items_per_page: 'trang' }}
                    defaultPageSize={params.limit}
                    defaultCurrent={params.page}
                    onChange={(page, limit) => {
                      setParams({
                        ...params,
                        page: page,
                        limit: limit
                      })
                    }}
                  />
                </div>
              </ConfigProvider>
            </div>
          </div>
          <div className={`right-content ${isCreateCondition === 0 ? 'd-none' : ''}`}>
            <div className="title-add-filter">
              <span>Chi tiết điều kiện gộp</span>
            </div>
            {/* <div className="content-filter-setting">
              {
                isCreateCondition !== 0
                  ? (
                    <Spin spinning={detailLoading}>
                      <Form
                        ref={formRef}
                        name="dynamic_form_add_seclect"
                        className="form-block d-none-rq form-benefit"
                        initialValues={{ remember: true }}
                        autoComplete="off"
                        layout="vertical"
                        onValuesChange={onValuesChange}
                        onFinish={onFinish}
                      >
                        <Form.Item
                          label="Tên điều kiện:"
                          name="title"
                          rules={[{ required: true, message: 'Nhập tên điều kiện!' }]}
                        >
                          <Input placeholder="Nhập tên điều kiện" />
                        </Form.Item>
                        <div className="status-add">
                          <label>Trạng thái</label>
                          <Form.Item
                            name="status"
                            style={{ marginBlockEnd: 0 }}
                          >
                            <Switch
                              className="rs-switch rs-switch--sm"
                            />
                          </Form.Item>
                        </div>

                        <Form.List name="conditions">
                          {(fields, { add, remove }) => (
                            <>
                              {fields.map(({ key, name, ...restField }) => (
                                <Space key={key} className='w-100' align="baseline">
                                  <DeleteFilled className='icon-delete' onClick={() => remove(name)} />
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'condition']}
                                    rules={[{ required: true, message: 'Vui lòng chọn điều kiện!' }]}
                                    shouldUpdate
                                  >
                                    <Select
                                      options={conditionList}
                                      className='rs-select rs-select--neutral-gray-100'

                                      placeholder="Chọn hệ thống"
                                      showSearch
                                      optionFilterProp="label"
                                      onFocus={() => newOptions()}
                                    />
                                  </Form.Item>
                                </Space>
                              ))}
                              <Form.Item>
                                <Button className='btn btn-primary-none-bg' type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                  Thêm điều kiện
                                </Button>
                              </Form.Item>
                            </>
                          )}
                        </Form.List>
                      </Form>
                    </Spin>
                  )
                  : <EmptyComponent content='Chưa có thông tin điều kiện gộp' />
              }
            </div> */}
            <PoolingDataDetailT stData={stData} stChange={(data) => {
              setStData((prev: any) => ({ ...prev, ...data }));
            }} />

            <div className="footer-filter-block">
              <div className="btn-block">
                <Button
                  className="rs-button rs-button--sm"
                  disabled={isCreateCondition === 0}
                  onClick={() => {
                    setIsCreateCondition(0)
                    setStData({
                      groups: [],
                      name: '',
                      desc: '',
                      clear: newid(),
                    })
                  }}
                >Hủy</Button>
                <Button
                  type={isCreateCondition === 0 ? 'default' : 'primary'}
                  className="rs-button rs-button--sm"
                  disabled={isCreateCondition === 0}
                  loading={formLoading}
                  onClick={onFormSubmit}
                >{isCreateCondition === 2 ? 'Lưu' : 'Tạo'}</Button>
              </div>
            </div>
          </div>
        </div>

        {
          isShowParam
            ? <ShowParam
              className="show"
              detailData={detailData}
              closeModal={() => setShowParam(!isShowParam)}
            />
            : null
        }

        <ModalParamCreate
          isOpen={openParamCreate}
          closeModal={() => setOpenParamCreate(!openParamCreate)} data={[]}
        />

        <ModalParamEdit
          isOpen={openParamEdit}
          closeModal={() => setOpenParamEdit(!openParamEdit)} data={[]}
        />
      </Layout>

      <ModalDeleteManager
        isOpen={showDeleteModal}
        onConfirm={deleteCondition}
        closeModal={() => setShowDeleteModal(false)}
        title="Bạn có chắc chắn xóa bộ điều kiện gộp này?"
        titleDelete="Xóa"
        content="Bộ điều kiện gộp và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục" />
    </div>
  );
}

export default PoolingDataSetup;
